import Form from '~/components/unform/Form'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import PublishersFieldset from '../../SelectPublishersV2'
import { useCampaignForm } from '../hooks/useCampaignForm'

const SelectPublisher: React.FC = () => {
  const { t } = useAPPTranslation()

  const { showPublisherFieldset } = useCampaignForm()

  return (
    showPublisherFieldset && (
      <Form>
        <PublishersFieldset
          description={t('rm:campaign.create.publisherdescription')}
        />
      </Form>
    )
  )
}

export default SelectPublisher
